import type { MarketingProcess } from '../../types/shared';

export const CAMPAIGN_NAME_FILTER: Record<MarketingProcess, string> = {
  'testing': 'CP-Test-Campaign-Template',
  'scaling': 'Scale-Campaign-template',
  'scaling_eg': 'Evergreen',
  'inbox': 'inbox',
  'hypothesis_testing': 'CP-Test-Campaign-Template',
};

export const SINGLE_AD_TYPE = 'single_ad';

export const FACEBOOK_AD_TYPE_CODES = ['dlo', 'endlo', 'single_ad'] as const;

export type FacebookAdTypeCode = (typeof FACEBOOK_AD_TYPE_CODES)[number];

export const isFacebookAdTypeCode = (
  value: string | null | undefined,
): value is FacebookAdTypeCode =>
  !!value && (FACEBOOK_AD_TYPE_CODES as readonly string[]).includes(value);